<section data-e2e="earn-cash-modal" class="ui modal earn-cash-modal" (keyup.enter)="save()">
  <i class="close icon"> <svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg> </i>
  <div data-e2e="title" class="header">
    <div class="title" i18n> Share Motive, Earn Cash </div>

    <div class="sub-title">
      <ng-container i18n>Know someone that could use Motive? </ng-container><br><ng-container i18n> Earn up to $1,000 for each referral.</ng-container>
      <br>
      <a href="https://gomotive.com/refer" target="_blank" rel="noopener noreferrer" class="ll" i18n>Learn More</a>
    </div>
  </div>

  <div class="content" [class.center]="inviteSent">
    <ng-container *ngIf="!inviteSent">
      <div data-e2e="group-name" class="ui form">
        <div class="sixteen wide field email-field-wrapper" [class.error]="entityEmailControl.invalid && entityEmailControl.dirty && !isInputEmailSeparator" (click)="focusInput($event)">
          <ng-container *ngIf="emails?.length > 0">
            <a class="ui label" *ngFor="let email of emails; let i = index">
              {{email}}
              <i class="delete icon" (click)="removeEmail(i)"></i>
            </a>
          </ng-container>

          <input [formControl]="entityEmailControl" [ngModel]="entityEmailControl.value" placeholder="name@company.com" (keydown)="onKey($event)" type="email" class="email" (keyup)="removeComma($event)">
        </div>

        <div class="input-helper">
          <ng-container i18n> Add multiple emails by separating with a comma </ng-container>

          <form-error [control]="entityEmailControl" *ngIf="entityEmailControl.invalid && !isInputEmailSeparator">
            <form-error-message *ngIf="entityEmailControl.dirty" type="required" i18n>Email is required</form-error-message>
            <form-error-message type="invalid" i18n>Email is not valid</form-error-message>
          </form-error>
        </div>

        <div class="sixteen wide field refer-message-wrapper">
          <h3 i18n>Message</h3>

          <p i18n>Motive makes fleet safety and tracking super simple with solutions like Smart Dashcams, ELD Compliance and GPS Tracking.</p>

          <p><ng-container i18n>You can save $100 or more towards your Motive purchase with my referral link: </ng-container><a href="{{referLink}}" target="_blank">{{referLink}}</a></p>

          <ng-container *ngIf="!isPersonalizeMessage">
            <div class="personalize-wrapper" (click)="personalizeMessage()" i18n>Personalize message</div>
          </ng-container>

          <ng-container *ngIf="isPersonalizeMessage">
            <div class="personalize-wrapper">
              <textarea [formControl]="entityMessageControl" [ngModel]="entityMessageControl.value" placeholder="Add a personal message here if you’d like" i18n-placeholder></textarea>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="inviteSent">
      <svg   width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 88c23.748 0 43-19.252 43-43S68.748 2 45 2 2 21.252 2 45s19.252 43 43 43zm0 2C20.147 90 0 69.853 0 45S20.147 0 45 0s45 20.147 45 45-20.147 45-45 45zm-7.778-30.494L66.92 29.808l1.415 1.414L38.636 60.92a2 2 0 0 1-2.828 0L21.666 46.778l1.414-1.414 14.142 14.142z" fill="#28A648"/></svg>
      <div class="success-msg" i18n>Message Sent</div>
    </ng-container>
  </div>

  <div class="ui active dimmer" *ngIf="isPreparing">
    <div class="ui indeterminate text loader" i18n>Preparing Cash</div>
  </div>

  <div class="content actions clearfix" *ngIf="!inviteSent">
    <div class="float-right">
      <button data-e2e="save" [class.loading]="isSending" [class.disabled]="emails?.length === 0 && (entityEmailControl.pending || entityEmailControl.invalid)" type="button" name="submit" class="ui left floated primary button" (click)="save()" i18n>Send invite</button>
    </div>
  </div>
</section>